import ToolbarStyled from './styled/ToolbarStyled'
import React from 'react'
import ToolbarItemStyled from './styled/ToolbarItemStyled'
import {
  FlexContainer,
  palette,
  UploadRoad,
  SaveRoad,
  PrintRoad,
  ReportRoad,
  Text,
} from '@busie/ui-kit'

interface Props {
  hasRoute: boolean
}

const Toolbar: React.FC<React.PropsWithChildren<Props>> = ({ hasRoute }) => {
  const options = !hasRoute
    ? [
        {
          label: 'Load saved road',
          Icon: UploadRoad,
          handler: console.log,
        },
      ]
    : [
        {
          label: 'Save',
          Icon: SaveRoad,
          handler: console.log,
        },
        {
          label: 'Print',
          Icon: PrintRoad,
          handler: console.log,
        },
        {
          label: 'Report',
          Icon: ReportRoad,
          handler: console.log,
        },
      ]
  return (
    <ToolbarStyled>
      {options.map((option, index) => (
        <ToolbarItemStyled key={index}>
          <FlexContainer
            columnGap={1}
            sx={{ cursor: 'pointer' }}
            align="center"
            onClick={option.handler}
          >
            <option.Icon />
            <Text
              color={palette.black.plus10}
              weight={500}
              style={{ lineHeight: '100%' }}
            >
              {option.label}
            </Text>
          </FlexContainer>
        </ToolbarItemStyled>
      ))}
    </ToolbarStyled>
  )
}

export default Toolbar
